import { Component, OnDestroy, OnInit } from '@angular/core';
import { Hotel, HotelOccupancy, HotelRevenue, TotalGuest } from '../../core/models/hotel';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { SortConfig } from '../../core/interface/SortConfig';
import { PaginationConfig } from '../../core/interface/PaginationConfig';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { HotelService } from '../../core/services/hotel.service';

@Component({
  selector: 'app-hotel',
  templateUrl: './hotel.component.html',
  styleUrl: './hotel.component.css'
})
export class HotelComponent implements OnInit, OnDestroy {

  expandedStates: boolean[] = [];
  isTotalExpanded: boolean = false;

  // Index untuk setiap section
  totalIndex: number = -1;
  roomIndex: number = -1;
  fbIndex: number = -1;
  fbRestoIndex: number = -1;
  fbMiceIndex: number = -1;
  otherIndex: number = -1;

  occupancyItem: HotelOccupancy[] = []
  totalGuestItem: TotalGuest[] = []
  revenueItem: HotelRevenue[] = []

  hotelItems: Hotel[] = [];
  isLoading: boolean = false;
  filteredData: Hotel[] = [];
  displayedData: Hotel[] = [];
  searchTerm: string = '';
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();
  startDate: string = '';
  endDate: string = '';

  sortConfig: SortConfig = {
    column: '',
    direction: ''
  };

  paginationConfig: PaginationConfig = {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0
  };

  findSectionIndexes() {
    console.log('Total items di revenueItem:', this.revenueItem.length);
    
    // Reset semua index ke -1 dulu
    this.totalIndex = -1;
    this.roomIndex = -1;
    this.fbIndex = -1;
    this.fbRestoIndex = -1;
    this.fbMiceIndex = -1;
    this.otherIndex = -1;
    
    // Cari index setiap section
    this.revenueItem.forEach((item, idx) => {
      console.log(`Item ${idx}:`, item.name);
      switch(item.name) {
        case 'Total': this.totalIndex = idx; break;
        case 'Room': this.roomIndex = idx; break;
        case 'F&B': this.fbIndex = idx; break;
        case 'F&B - Restaurant': this.fbRestoIndex = idx; break;
        case 'F&B - Mice': this.fbMiceIndex = idx; break;
        case 'Other': this.otherIndex = idx; break;
      }
    });

    // 🔥 Ubah dari fill(false) menjadi fill(true)
    this.expandedStates = new Array(this.revenueItem.length).fill(false); // ✅ SEMUA EXPANDED
    
    // 🔥 Set isTotalExpanded menjadi true juga
    this.isTotalExpanded = false;
  }

  constructor(
    private router: Router,
    private hotelService: HotelService,
    private route: ActivatedRoute
  ) {
    this.setupSearchSubscription();
  }

  private setupSearchSubscription(): void {
    this.searchSubject.pipe(
      takeUntil(this.destroy$),
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(term => {
      // Update URL dan load data hanya jika ada term
      if (term.trim()) {
        this.updateUrlParams();
      }
      this.loadHotelData(term);
    });
  }

  ngOnInit(): void {
    const startDate = localStorage.getItem('startDate')
    const endDate = localStorage.getItem('endDate')

    this.startDate = startDate ? startDate : '';
    this.endDate = endDate ? endDate : '';

    this.loadhotelOccupancy();
    this.loadTotalGuest();
    this.loadhotelRevenue();

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.searchTerm = params['search'] || '';
        // Perbaikan mapping parameter sorting
        this.sortConfig.column = params['sortColumn'] || '';
        this.sortConfig.direction = params['sortDirection'] as 'ASC' | 'DESC' | '' || '';
        this.paginationConfig.currentPage = Number(params['page']) || 1;

        this.loadHotelData(this.searchTerm);
      });

    this.revenueItem.forEach((item, idx) => {
      switch(item.name) {
        case 'Room': this.roomIndex = idx; break;
        case 'F&B': this.fbIndex = idx; break;
        case 'F&B - Restaurant': this.fbRestoIndex = idx; break;
        case 'F&B - Mice': this.fbMiceIndex = idx; break;
        case 'Other': this.otherIndex = idx; break;
      }
    });

    // Inisialisasi expandedStates
    this.isTotalExpanded = false;
    this.expandedStates = new Array(this.revenueItem.length).fill(false);

  }

  // Toggle Total (Master)
  
  toggleTotal() {
    console.log('=== TOGGLE TOTAL DIPANGGIL ===');
    console.log('Sebelum:', {
        isTotalExpanded: this.isTotalExpanded,
        expandedStates: [...this.expandedStates]
    });
    
    this.isTotalExpanded = !this.isTotalExpanded;
    
    console.log('Setelah toggle:', {
        isTotalExpanded: this.isTotalExpanded,
        akan_set_semua_ke: this.isTotalExpanded
    });
    // Expand/collapse semua section
    if (this.roomIndex !== -1) {
        this.expandedStates[this.roomIndex] = this.isTotalExpanded;
        console.log(`Room (index ${this.roomIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.fbIndex !== -1) {
        this.expandedStates[this.fbIndex] = this.isTotalExpanded;
        console.log(`F&B (index ${this.fbIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.fbRestoIndex !== -1) {
        this.expandedStates[this.fbRestoIndex] = this.isTotalExpanded;
        console.log(`F&B Restaurant (index ${this.fbRestoIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.fbMiceIndex !== -1) {
        this.expandedStates[this.fbMiceIndex] = this.isTotalExpanded;
        console.log(`F&B Mice (index ${this.fbMiceIndex}) → ${this.isTotalExpanded}`);
    }
    if (this.otherIndex !== -1) {
        this.expandedStates[this.otherIndex] = this.isTotalExpanded;
        console.log(`Other (index ${this.otherIndex}) → ${this.isTotalExpanded}`);
    }
    console.log('Akhir:', {
        isTotalExpanded: this.isTotalExpanded,
        expandedStates: [...this.expandedStates]
    });
  }

  // Toggle individual section
  toggleExpand(index: number) {
    this.expandedStates[index] = !this.expandedStates[index];
  }

  loadhotelOccupancy(): void {
    this.isLoading = true;

    this.hotelService.getHotelOccupancy(
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.occupancyItem = response.data;
        this.paginationConfig.totalItems = response.pagination.total_items;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading hotel occupancy data:', error);
        this.isLoading = false;
        this.occupancyItem = [];
      }
    });
  }

  loadhotelRevenue(): void {
    this.isLoading = true;

    this.hotelService.getHotelRevenue(
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.revenueItem = response.data;
        console.log(this.revenueItem);
        this.paginationConfig.totalItems = response.pagination.total_items;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading hotel revenue data:', error);
        this.isLoading = false;
        this.revenueItem = [];
      }
    });
  }

  loadTotalGuest(): void {
    this.isLoading = true;

    this.hotelService.getTotalGuess(
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      this.startDate,
      this.endDate,
    ).subscribe({
      next: (response) => {
        this.totalGuestItem = response.data;
        // console.log(this.totalGuestItem);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading hotel occupancy data:', error);
        this.isLoading = false;
        this.occupancyItem = [];
      }
    });
  }

  loadHotelData(searchTerm?: string): void {
    this.isLoading = true;

    this.hotelService.getHotels(
      this.paginationConfig.currentPage,
      this.paginationConfig.itemsPerPage,
      searchTerm?.trim() || '',
      this.sortConfig.column,
      this.sortConfig.direction.toUpperCase() as 'ASC' | 'DESC',
      this.startDate,
      this.endDate
    ).subscribe({
      next: (response) => {
        this.displayedData = response.data;

        // console.log(this.displayedData);
        this.paginationConfig.totalItems = response.pagination.total_items;
        this.isLoading = false;
        this.findSectionIndexes();
      },
      error: (error) => {
        console.error('Error loading hotel data:', error);
        this.isLoading = false;
        this.displayedData = [];
      }
    });
  }

  get totalPages(): number {
    return Math.ceil(this.paginationConfig.totalItems / this.paginationConfig.itemsPerPage);
  }

  get pageNumbers(): number[] {
    const currentPage = this.paginationConfig.currentPage;
    const totalPages = this.totalPages;

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  onSearch(event: KeyboardEvent): void {
    const target = event.target as HTMLInputElement;
    const term = target.value;

    // Update searchTerm dan trigger pencarian
    this.searchTerm = term;
    this.paginationConfig.currentPage = 1;
    this.searchSubject.next(term);

    // Jika input kosong, langsung clear search dan reset data
    if (!term.trim()) {
      const queryParams: Record<string, string | number | null> = {
        page: 1,
        search: null
      };

      // Jika ada sort config, pertahankan
      if (this.sortConfig.column && this.sortConfig.direction) {
        queryParams['sortColumn'] = this.sortConfig.column;
        queryParams['sortDirection'] = this.sortConfig.direction;
      }

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        replaceUrl: true
      });

      this.loadHotelData('');
    }
  }

  onSort(column: string): void {
    if (this.sortConfig.column === column) {
      // Toggle direction jika kolom yang sama diklik
      this.sortConfig.direction = this.sortConfig.direction === 'ASC' ? 'DESC' : 'ASC';
    } else {
      // Set kolom baru dan mulai dari ASC
      this.sortConfig.column = column;
      this.sortConfig.direction = 'ASC';
    }

    this.paginationConfig.currentPage = 1; // Reset ke halaman pertama
    this.updateUrlParams();
    this.loadHotelData(this.searchTerm);
  }

  getSortIcon(column: string): string {
    // Jika bukan kolom yang sedang di-sort, tampilkan icon default
    if (this.sortConfig.column !== column) {
      return 'ri-expand-up-down-line'; // Remix icon untuk unsorted
    }

    // Jika kolom yang sedang di-sort
    if (this.sortConfig.direction === 'ASC') {
      return 'ri-arrow-up-line'; // Remix icon arrow up
    } else if (this.sortConfig.direction === 'DESC') {
      return 'ri-arrow-down-line'; // Remix icon arrow down
    }

    return 'ri-expand-up-down-line'; // Default fallback
  }

  onPageChange(page: number): void {
    if (page < 1 || page > this.totalPages || page === this.paginationConfig.currentPage) {
      return;
    }

    this.paginationConfig.currentPage = page;
    this.updateUrlParams();
    this.loadHotelData(this.searchTerm);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFirstPage(): void {
    this.onPageChange(1);
  }

  onLastPage(): void {
    this.onPageChange(this.totalPages);
  }

  onPrevPage(): void {
    this.onPageChange(this.paginationConfig.currentPage - 1);
  }

  onNextPage(): void {
    this.onPageChange(this.paginationConfig.currentPage + 1);
  }

  get displayRange(): { start: number; end: number; total: number } {
    const start = (this.paginationConfig.currentPage - 1) * this.paginationConfig.itemsPerPage + 1;
    const end = Math.min(
      start + this.paginationConfig.itemsPerPage - 1,
      this.paginationConfig.totalItems
    );

    return {
      start: this.paginationConfig.totalItems === 0 ? 0 : start,
      end,
      total: this.paginationConfig.totalItems
    };
  }

  private updateUrlParams(): void {
    const queryParams: any = {
      page: this.paginationConfig.currentPage
    };

    // Tambahkan search param jika ada nilai
    if (this.searchTerm?.trim()) {
      queryParams.search = this.searchTerm.trim();
    } else {
      queryParams.search = null; // Hapus search param
    }

    // Tambahkan sorting params jika ada
    if (this.sortConfig.column && this.sortConfig.direction) {
      queryParams.sortColumn = this.sortConfig.column;
      queryParams.sortDirection = this.sortConfig.direction;
    } else {
      // Hapus sorting params jika tidak ada
      queryParams.sortColumn = null;
      queryParams.sortDirection = null;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.paginationConfig.currentPage = 1;
    this.updateUrlParams();
    this.loadHotelData('');
  }

  getFbTotal(): number {
    const restaurant = this.revenueItem.find(item => item.name === 'F&B - Restaurant');
    const mice = this.revenueItem.find(item => item.name === 'F&B - Mice');
    
    const restaurantTotal = restaurant ? restaurant.total : 0;
    const miceTotal = mice ? mice.total : 0;
    
    return Math.round(restaurantTotal + miceTotal);
  }

  getFbBudget(): number {
    const restaurant = this.revenueItem.find(item => item.name === 'F&B - Restaurant');
    const mice = this.revenueItem.find(item => item.name === 'F&B - Mice');
    
    const restaurantTotal = restaurant ? restaurant.budget : 0;
    const miceTotal = mice ? mice.budget : 0;
    
    return Math.round(restaurantTotal + miceTotal);
  }

  getFbPct(): number {
    const fbTotal =  this.getFbTotal();
    const fbBudget = this.getFbBudget();
    
    if (fbBudget === 0) {
      return 100;
    }
    
    return Math.round(((fbTotal - fbBudget) / fbBudget * 100) * 100) / 100;
  }

  getTotalRevenue(): number {
    return this.revenueItem.reduce((total, item) => total + item.total, 0);
  }

  // getTotalBudget(): string {
    // Logika untuk mendapatkan total budget
    // Sesuaikan dengan data yang Anda miliki
  //  return 'Rp.2,951,524,479';
  //}
  get totalRevenueOnly(): HotelRevenue[] {
      return this.revenueItem.filter(item => item.name === 'Total');
    }
  getPercentageClass(percentage: number): string {
    if (percentage >= 100) {
      return 'badge custom-progress-success';
    }
    return 'badge custom-progress-danger';
  }
}
